<template>
  <div class="feature-chat-wrapper">
    <div
      class="chat-bubble chat-bubble--blue"
      :class="{ visible: showBlue }"
    >
      <p class="smaller white original">
        {{ typing1 }}
      </p>

      <div class="bubble-divider bubble-divider--blue" />

      <p class="small white">
        {{ typing2 }}
      </p>
    </div>

    <div
      class="chat-bubble chat-bubble--gray"
      :class="{ visible: showGray }"
    >
      <p class="smaller original">
        {{ typing3 }}
      </p>

      <div class="bubble-divider bubble-divider--gray" />

      <p class="small">
        {{ typing4 }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const text1 = '스콘챗은 실시간 AI 통역 서비스 입니다.'
const text2 = 'SconChat is a real-time AI Interpretation service.'

const text3 = '이제 언어장벽 없이 끊임없는 대화를 즐길 수 있겠네요!'
const text4 = 'Now we can enjoy the seamless conversation without language barriers!'

const typing1 = ref('')
const typing2 = ref('')
const typing3 = ref('')
const typing4 = ref('')

const showBlue = ref(false)
const showGray = ref(false)

const typingSpeed = 45
const fadeDuration = 700
const holdAfterAll = 10000

function typeText(target: any, text: string) {
  return new Promise<void>((resolve) => {
    let i = 0
    target.value = ''

    const type = () => {
      if (i < text.length) {
        target.value += text.charAt(i)
        i++
        setTimeout(type, typingSpeed)
      } else {
        resolve()
      }
    }

    type()
  })
}

async function startSequence() {
  showBlue.value = false
  showGray.value = false
  typing1.value = ''
  typing2.value = ''
  typing3.value = ''
  typing4.value = ''

  showBlue.value = true
  await Promise.all([
    typeText(typing1, text1),
    typeText(typing2, text2),
  ])

  showGray.value = true
  await Promise.all([
    typeText(typing3, text3),
    typeText(typing4, text4),
  ])

  setTimeout(() => {
    showBlue.value = false
    showGray.value = false

    setTimeout(startSequence, fadeDuration + 300)
  }, holdAfterAll)
}

onMounted(startSequence)
</script>

<style scoped>

.feature-chat-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 21rem;
}

.chat-bubble {
  display: flex;
  flex-direction: column;
  width: 16rem;
  min-height: 5rem;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  opacity: 0;
  gap: 0.5rem;
  transition: opacity 0.7s ease;
  text-align: left;
}

.chat-bubble.visible {
  opacity: 1;
}

.chat-bubble--blue {
  background: #5865e0;
}

.chat-bubble--gray {
  background: #f0f0ef;
}

.original {
  opacity: 0.5 !important;
}

.bubble-divider {
  height: 1px;
  width: 100%;
}

.bubble-divider--blue {
  background: rgba(255, 255, 255, 0.3);
}

.bubble-divider--gray {
  background: rgba(0, 0, 0, 0.15);
}
</style>
